const getBrandByIdProducts = /* GraphQL */ `
query GetBrandById($input: inputGetById!) {
  getBrandById(input: $input) {
    title
	products {
		__typename
		id
		abv
		color
		isNewProduct
		isHiddenExternally
		tastingExperience
      	description
      	slug
      	title
		assets {
          __typename
			id
			alt
			... on S3Asset {
				path
			}
			... on CloudinaryAsset {
				cloudinaryId
			}
      	}
		brand {
			id
			title
			displayTitle
			slug
		}
		traits {
			allergens
			availability
			otherTraits
		}
		... on Beer {
			originalGravity
			srm
			ibu
			styleAlias
            style {
                title
                category {
                    title
                }
                id
                label
                slug
                title
            }
		}
		... on Kombucha {
			kombuchaFamily
			
		}
		... on Cider {
			ciderFamily
		}
	}
  }
}
`

export default getBrandByIdProducts
